<div class="control-panel ag-pa-md">
  <!-- create a New Widget -->
  @if (pageStart && pageType === CREATE_NEW_PAGE_TYPE_ENUM.WIDGET) {
    <h3 class="text-center" style="margin-top: 10px">Create New Widget</h3>
    <div class="edit-content">
      <div class="page-content-wrapper">
        <div class="form-group">
          <label for="newWidgetTitle">New Widget Title</label>
          <input
            #pageTitle
            id="newWidgetTitle"
            type="text"
            class="form-control"
            [(ngModel)]="pageLabel"
            aria-describedby="pageLabel"
          />
        </div>
      </div>
      <!-- Cancel and Create-->
      <div class="text-end action-buttons">
        <button
          type="button"
          role="button"
          aria-label="Cancel"
          class="btn btn-link"
          (click)="closePageDialog()"
        >
          Cancel
        </button>
        <button
          type="button"
          role="button"
          aria-label="Create Page"
          class="btn btn-lg btn-primary"
          (click)="createNewPageOrWidget()"
        >
          Create Widget
        </button>
      </div>
    </div>
  }

  <!-- Create a New Page -->
  @if (pageStart && pageType === CREATE_NEW_PAGE_TYPE_ENUM.PAGE) {
    <h3 class="text-center" style="margin-top: 10px">Create New Page</h3>
    <div class="edit-content">
      <div class="page-content-wrapper">
        <label for="newPageTitle">New Page Title</label>
        <input
          #pageTitle
          id="newPageTitle"
          type="text"
          class="form-control"
          [(ngModel)]="pageLabel"
          aria-describedby="pageLabel"
        />
        <small class="form-text">The name for this page, as it appears in navigation.</small>
      </div>
      <!-- Page/Settings - Layout -->
      <div class="page-content-wrapper ag-mt-sm">
        <label for="selectForm">Page Layout</label>
        <small class="form-text ag-mb-sm" style="display: block"
          >Layout Base with enhanced mobility.</small
        >
        <div class="container">
          <div class="row">
            <div class="col-4 col-lg-4">
              <input
                type="radio"
                name="group"
                value="aboutOne"
                checked
                (change)="selectedTemplate($event)"
              />
              <img src="./assets/images/page-layout/about-1.png" alt="about 1" />
            </div>
            <div class="col-4 col-lg-4">
              <input
                type="radio"
                name="group"
                value="aboutThree"
                (change)="selectedTemplate($event)"
              />
              <img src="./assets/images/page-layout/about-3.png" alt="about 3" />
            </div>
            <div class="col-4 col-lg-4">
              <input
                type="radio"
                name="group"
                value="contactTwo"
                (change)="selectedTemplate($event)"
              />
              <img src="./assets/images/page-layout/contact-2.png" alt="contact 2" />
            </div>
            <div class="col-4 col-lg-4">
              <input
                type="radio"
                name="group"
                value="contactThree"
                (change)="selectedTemplate($event)"
              />
              <img src="./assets/images/page-layout/contact-3.png" alt="contact 3" />
            </div>
            <div class="col-4 col-lg-4">
              <input
                type="radio"
                name="group"
                value="detailsOne"
                (change)="selectedTemplate($event)"
              />
              <img src="./assets/images/page-layout/detail-1.png" alt="detail 1" />
            </div>
            <div class="col-4 col-lg-4">
              <input
                type="radio"
                name="group"
                value="detailsTwo"
                (change)="selectedTemplate($event)"
              />
              <img src="./assets/images/page-layout/detail-2.png" alt="detail 2" />
            </div>
            <div class="col-4 col-lg-4">
              <input
                type="radio"
                name="group"
                value="detailsThree"
                (change)="selectedTemplate($event)"
              />
              <img src="./assets/images/page-layout/detail-3.png" alt="detail 3" />
            </div>
            <div class="col-4 col-lg-4">
              <input
                type="radio"
                name="group"
                value="featuresOne"
                (change)="selectedTemplate($event)"
              />
              <img src="./assets/images/page-layout/feature-1.png" alt="feature 1" />
            </div>
            <div class="col-4 col-lg-4">
              <input
                type="radio"
                name="group"
                value="featuresTwo"
                (change)="selectedTemplate($event)"
              />
              <img src="./assets/images/page-layout/feature-2.png" alt="feature 2" />
            </div>
            <div class="col-4 col-lg-4">
              <input
                type="radio"
                name="group"
                value="featuresThree"
                (change)="selectedTemplate($event)"
              />
              <img src="./assets/images/page-layout/feature-3.png" alt="feature 3" />
            </div>
            <div class="col-4 col-lg-4">
              <input
                type="radio"
                name="group"
                value="imagesOne"
                (change)="selectedTemplate($event)"
              />
              <img src="./assets/images/page-layout/image-1.png" alt="image 1" />
            </div>
            <div class="col-4 col-lg-4">
              <input
                type="radio"
                name="group"
                value="imagesTwo"
                (change)="selectedTemplate($event)"
              />
              <img src="./assets/images/page-layout/image-3.png" alt="image 3" />
            </div>
            <div class="col-4 col-lg-4">
              <input
                type="radio"
                name="group"
                value="TeamsOne"
                (change)="selectedTemplate($event)"
              />
              <img src="./assets/images/page-layout/team-1.png" alt="team 1" />
            </div>
            <div class="col-4 col-lg-4">
              <input
                type="radio"
                name="group"
                value="TeamsTwo"
                (change)="selectedTemplate($event)"
              />
              <img src="./assets/images/page-layout/team-2.png" alt="team 2" />
            </div>
            <div class="col-4 col-lg-4">
              <input
                type="radio"
                name="group"
                value="TeamsThree"
                (change)="selectedTemplate($event)"
              />
              <img src="./assets/images/page-layout/team-3.png" alt="team 3" />
            </div>
          </div>
        </div>
      </div>
      <!-- Cancel and Create-->
      <div class="text-end" style="margin: 30px 20px 0 0">
        <button
          type="button"
          role="button"
          aria-label="Cancel"
          class="btn btn-link"
          (click)="closePageDialog()"
        >
          Cancel
        </button>
        <button
          type="button"
          role="button"
          aria-label="Create Page"
          class="btn btn-lg btn-primary"
          (click)="createNewPageOrWidget()"
        >
          Create Page
        </button>
      </div>
    </div>
  }

  <!-- Create a Page Link -->
  @if (pageStart && pageType === CREATE_NEW_PAGE_TYPE_ENUM.LINK) {
    <h3 class="text-center" style="margin-top: 10px">Create Page Link</h3>
    <h6 class="text-center">Note:link page cannot be the home page</h6>
    <div class="edit-content">
      <div class="page-content-wrapper">
        <div class="form-group">
          <label for="pageLinkTitle">Page Link Title</label>
          <input
            #pageTitle
            id="pageLinkTitle"
            type="text"
            class="form-control"
            [(ngModel)]="pageLabel"
            aria-describedby="pageLabel"
            placeholder="Enter Name"
          />
          <small class="form-text">The name for this page, as it appears in navigation.</small>
        </div>
        <div style="border: 2px solid var(--header-color); width: 115%">
          <!-- visibility for page links -->
          <div style="margin-bottom: 15px; padding: 17px 0 5px 17px">
            Visibility:
            <mat-checkbox
              [(ngModel)]="showGuest"
              class="d-inline margin-right-15px !important; margin-left:10px !important"
              >Guest</mat-checkbox
            >
            <mat-checkbox [(ngModel)]="showPatron" class="d-inline margin-right-15px !important;"
              >Patron</mat-checkbox
            >
            <mat-checkbox [(ngModel)]="showStaff" class="d-inline">Staff</mat-checkbox><br />
          </div>
          <!-- activate pages logic -->
          <div class="width-100 padding-10" style="font-size: 14px; padding: 17px 0 15px 17px">
            <mat-checkbox (change)="activate($event)" [checked]="active">Active Now</mat-checkbox>
            <span style="vertical-align: 0.5vh; margin-left: 10px; margin-right: 10px">
              <h6 class="d-inline">OR</h6>
            </span>
            <mat-checkbox
              class="margin-right-10"
              (change)="activateOnDate()"
              [checked]="activeOnDate"
              >Active on a Date</mat-checkbox
            >
            @if (!active && activeOnDate) {
              <div style="display: inline-block" class="calender-box text-start">
                <input
                  id="activateDate"
                  class="date-input"
                  type="text"
                  aria-describedby="activateDate"
                  placeholder="mm/dd/yyyy"
                  title="Active Date"
                  [min]="minDate"
                  [(ngModel)]="activeDate"
                  [matDatepicker]="activeDatePicker"
                  readonly
                />
                <mat-datepicker-toggle
                  matIconSuffix
                  [for]="activeDatePicker"
                ></mat-datepicker-toggle>
                <mat-datepicker #activeDatePicker></mat-datepicker>
              </div>
            }
          </div>
        </div>
        @if (CSU) {
          <div style="border: 2px solid var(--header-color); margin-top: 15px; width: 115%">
            <!-- publish logic --->
            <div class="width-100 padding-10" style="font-size: 14px">
              <mat-checkbox
                (change)="publishdate($event)"
                [checked]="publish"
                aria-hidden="true"
                style="font-size: 14px"
                >Publish page to other libraries</mat-checkbox
              >
              @if (!allLibs && publish) {
                <mat-form-field style="width: 30%; margin-left: 10px">
                  <mat-select placeholder="Select Libraries" [formControl]="allLibraries" multiple>
                    <mat-select-trigger>
                      {{ allLibraries.value ? allLibraries.value[0] : '' }}
                      @if (allLibraries.value?.length > 1) {
                        <span class="example-additional-selection">
                          (+{{ allLibraries.value.length - 1 }} others)
                        </span>
                      }
                    </mat-select-trigger>
                    @for (library of allLibrariesList; track library) {
                      <mat-option
                        class="hide-ellipsis-ff"
                        [value]="$safeNavigationMigration(library?.lid)"
                        >{{ library?.name }}</mat-option
                      >
                    }
                  </mat-select>
                </mat-form-field>
              }
              <span style="vertical-align: 0.5vh; margin-left: 10px; margin-right: 10px">
                <h6 class="d-inline">OR</h6>
              </span>
              <mat-checkbox
                (change)="allLibsPublish($event)"
                [checked]="allLibs"
                aria-hidden="true"
                matTooltip="Publish Page to All Libraries."
                style="font-size: 14px"
                >Publish to all libraries</mat-checkbox
              >
            </div>
            @if (showPublishDateSettings) {
              <div class="padding-10" style="font-size: 14px; width: 120%">
                <mat-checkbox (change)="forceActive($event)" [checked]="forceActiveState"
                  >Force Active Page Now</mat-checkbox
                >
                <span style="vertical-align: 0.5vh; margin-left: 10px; margin-right: 10px">
                  <h6 class="d-inline">OR</h6>
                </span>
                <mat-checkbox
                  (change)="publishActivateOnDate($event)"
                  [checked]="publishActiveOnDate"
                  style="margin-right: 10px"
                  >Active on a Date</mat-checkbox
                >
                @if ((allLibs || publish) && publishActiveOnDate) {
                  <div style="display: inline-block" class="calender-box text-start">
                    <input
                      id="publishDate"
                      class="date-input"
                      type="text"
                      aria-describedby="publishDate"
                      placeholder="mm/dd/yyyy"
                      title="Publish Date"
                      [min]="minDate"
                      [(ngModel)]="publishDate"
                      [matDatepicker]="publishDatePicker"
                      readonly
                    />
                    <mat-datepicker-toggle
                      matIconSuffix
                      [for]="publishDatePicker"
                    ></mat-datepicker-toggle>
                    <mat-datepicker #publishDatePicker></mat-datepicker>
                  </div>
                }
              </div>
            }
          </div>
        }
        <div class="form-group">
          <label for="redirectURL">Re-direct link</label>
          <input
            type="text"
            class="form-control"
            [(ngModel)]="redirectUrl"
            id="redirectURL"
            aria-describedby="redirect url"
          />
          <small id="publishDateHelp" class="form-text">Enter a redirect URL</small>
        </div>
      </div>
      <!-- Cancel and Create-->
      <div class="text-end margin-10-0">
        <button
          type="button"
          role="button"
          aria-label="Cancel"
          class="btn btn-link"
          (click)="closePageDialog()"
        >
          Cancel
        </button>
        <button
          type="button"
          role="button"
          aria-label="Create"
          class="btn btn-lg btn-primary"
          (click)="createLinkPage()"
        >
          Create
        </button>
      </div>
    </div>
  }
</div>
